import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { ComplaintsApi } from "apis/Complaint";
import { useNavigate } from "react-router";
import {
  Box,
  Button,
  createSvgIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  // FormControlLabel,
  // FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  // Radio,
  // RadioGroup,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import TableElement from "../../components/Table/TableElement";
import TableHeader from "components/Table/TableHeader";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import { setLoadingPanel } from "../../redux/features/loading";
import { BrandsApi } from "apis/BrandsApi";
import ComplaintAddDialog from "components/Dialog/ComplaintAddDialog";
import { formatDateTime } from "utils";
import { formatDateTimeComponent } from "utils";

export default function Complaints() {
  const dispatch = useDispatch();
  const [brands, setBrands] = useState([]);
  const [ResolveComplaint, setResolveComplaint] = useState(false);
  // const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedBrandDialog, setSelectedBrandDialog] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [mobile, setMobile] = useState("");
  const [filterBrands, setFilterBrands] = useState("");
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [selectedType, setSelectedType] = useState("COMPLAIN");
  const [ComplaintData, setComplaintData] = useState([]);
  const [AddComplaint, setAddComplaint] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalElements, setTotalElements] = useState(0);
  const [fetchSize, setFetchSize] = useState(50);
  const [id, setId] = useState("");

  const PlusIcon = createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>,
    "Plus"
  );

  const [formData, setFormData] = useState({
    brandId: null,
    type: null,
    description: "",
    image: "",
    size: 5,
  });

  const handleSubmitForm = async (payload, mobile) => {
    try {
      const validationError = validateFunction(payload);
      if (validationError) {
        toast(validationError, {
          type: "warning",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px auto",
            padding: "5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        return;
      }
      if (mobile) {
        await ComplaintsApi.AddComplaintsMobileNumber(payload, mobile);
      } else {
        await ComplaintsApi.AddComplaints(payload);
      }
      fetchComplaints();
      toast("Your Complaint was created successfully.", {
        type: "success",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px auto",
          padding: "5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
      setAddComplaint(false);
      setFormData({
        brandId: "",
        type: "",
        description: "",
        image: "",
      });
      setImagePreview(null);
    } catch (err) {
      const status = err?.response?.status;
      const message =
        err?.response?.data?.message || "An unexpected error occurred";
      toast(`${status ? `${status} ` : ""}${message}`, {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px auto",
          padding: "5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
      if (status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const validateFunction = (payload) => {
    if (!payload.type) return "Please select a complaint type.";
    if (!payload.brandId) return "Please select a brand.";
    if (!payload.description) return "Please provide a complaint description.";
    return null;
  };

  const getBrands = () => {
    dispatch(setLoadingPanel(true));
    BrandsApi.GetBrandsListByFilter({
      page: 0,
      size: 99,
    })
      .then((res) => {
        const filteredBrands = res.data.data.filter((d) => d.isActive);
        setBrands(filteredBrands);
        // setSelectedBrand(filteredBrands[0]);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px auto",
              padding: "5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px auto",
              padding: "5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setImagePreview(URL.createObjectURL(file));
    let body = new FormData();
    body.append("document", file);
    try {
      const { data } = await ComplaintsApi.uploadPhotoConnect(body, "KONNECT");
      setFormData((prev) => ({ ...prev, image: data.data.url }));
    } catch (err) {
      toast(err.response?.status + " " + err?.response?.data?.message, {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px  auto",
          padding: "5px 5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
    }
  };

  const fetchComplaints = async () => {
    dispatch(setLoadingPanel(true));
    try {
      const { data } = await ComplaintsApi.GetComplaintsByFilter({
        page: currentPage - 1,
        size: fetchSize,
        brandId: formData.brandId,
        type: formData.type,
      });
      setComplaintData(data.data);
      setTotalPages(data.pages);
      setTotalElements(data.totalElements);
      dispatch(setLoadingPanel(false));
    } catch (err) {
      dispatch(setLoadingPanel(false));
      const status = err?.response?.status;
      const message =
        err?.response?.data?.message || "An unexpected error occurred";
      toast(`${status ? `${status} ` : ""}${message}`, {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px auto",
          padding: "5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
      if (status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    fetchComplaints();
  }, [currentPage, formData.brandId, formData.type, fetchSize]);

  useEffect(() => {
    getBrands();
  }, []);

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handleChange = (event) => {
    setCurrentPage(1);
    setSelectedType(event.target.value);
    setFormData({
      ...formData,
      type: event.target.value,
    });
    setFilterBrands("");
  };

  const filterComplaintsByBrand = (complaints, selectedBrand) => {
    if (!selectedBrand) return complaints;
    return complaints.filter(
      (complaint) => complaint?.brand.id === selectedBrand.id
    );
  };

  const addComplaint = () => {
    setAddComplaint(true);
  };

  const complaintTypesAdd = [
    { label: "Complaint", value: "COMPLAIN" },
    { label: "Feedback", value: "FEEDBACK" },
    { label: "Suggestion", value: "SUGGESTION" },
    { label: "Opportunity", value: "OPPORTUNITY" },
  ];

  return (
    <>
      <CircularIndeterminateModal open={isLoading} />
      <div
        className="page-card mb-6"
      >
        <div className="w-full lg:w-[70%] p-4 md:p-8">
          <Box className="w-full">
            <FormControl fullWidth>
              <InputLabel
                id="demo-simple-select-label"
                className="text-sm md:text-base"
              >
                Select Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedType}
                label={
                  <span className="text-sm md:text-base font-medium">Type</span>
                }
                onChange={handleChange}
                sx={{
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "13px",
                    lg: "16px",
                  },
                }}
                className="min-h-[40px] md:min-h-[52px]"
              >
                {["COMPLAIN", "FEEDBACK", "SUGGESTION", "OPPORTUNITY"].map(
                  (b, i) => (
                    <MenuItem
                      key={i}
                      value={b}
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "13px",
                          md: "13px",
                          lg: "16px",
                        },
                      }}
                    >
                      {b}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Box>
        </div>

        <div className="w-full lg:w-[30%] md:p-8 p-4 flex items-center">
          <Button
            onClick={addComplaint}
            fullWidth
            variant="contained"
            color="primary"
            sx={{
              height: { xs: "40px", md: "52px" },
              fontSize: {
                xs: "12px",
                sm: "13px",
                md: "13px",
                lg: "16px",
              },
            }}
            startIcon={<PlusIcon className="h-4 w-4 md:h-5 md:w-5" />}
          >
            Add Complaint
          </Button>
        </div>
      </div>
      <div
        className="page-card mb-6"
      >
        <div className="w-full md:p-4 p-2 flex items-center justify-center">
          <Button
            onClick={() => {
              setCurrentPage(1);
              setFilterBrands("");
              setFormData({
                ...formData,
                brandId: null,
                type: "COMPLAIN",
                description: "",
                image: "",
              });
              setImagePreview(null);
              setSelectedType("COMPLAIN");
              setFetchSize(50);
            }}
            variant="contained"
            size="small"
            color="secondary"
            className="whitespace-nowrap"
            sx={{
              height: { xs: "40px", md: "52px" },
              fontSize: {
                xs: "12px",
                sm: "13px",
                md: "13px",
                lg: "16px",
              },
            }}
          >
            Reset All{" "}
          </Button>
        </div>
      </div>
      <div
        className="page-card mb-6"
      >
        <Grid item xs={12} md={6}>
          <Box className="w-full">
            <FormControl fullWidth>
              <InputLabel
                id="brand-select-label"
                className="text-sm md:text-base"
              >
                Brand
              </InputLabel>
              <Select
                labelId="brand-select-label"
                id="brand-select"
                value={filterBrands || ""}
                label={
                  <span className="text-sm md:text-base font-medium">
                    Brand
                  </span>
                }
                sx={{
                  fontSize: {
                    xs: "12px",
                    sm: "13x",
                    md: "13px",
                    lg: "16px",
                  },
                }}
                onChange={(e) => {
                  setCurrentPage(1);
                  setFilterBrands(e.target.value);
                  setFormData({ ...formData, brandId: e.target.value.id });
                }}
                className="min-h-[40px] md:min-h-[52px]"
              >
                {brands.map((brand, index) => (
                  <MenuItem
                    key={index}
                    value={brand}
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13x",
                        md: "13px",
                        lg: "16px",
                      },
                    }}
                  >
                    {brand.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </div>
      <div
        className="page-card mb-6"
      >
        <div className="block w-full overflow-x-auto py-3 px-5 lg:p-8">
          <div className="mx-2 my-4 flex md:justify-start justify-center">
            <Stack
              direction={{ md: "row", xs: "column" }}
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Stack
                spacing={{ xs: 1, lg: 3 }}
                direction={{ xs: "column", md: "row" }}
                divider={<Divider orientation="vertical" flexItem />}
                className="items-center lg:items-start"
              >
                <FormControl>
                  <InputLabel
                    id="size-select-label"
                    className="text-sm lg:text-base"
                  >
                    Size
                  </InputLabel>
                  <Select
                    labelId="size-select-label"
                    id="size-select"
                    size="small"
                    value={fetchSize}
                    label={
                      <span className="text-sm lg:text-base font-medium">
                        Size
                      </span>
                    }
                    onChange={(e) => {
                      setCurrentPage(1);
                      setFetchSize(e.target.value);
                    }}
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "13px",
                        lg: "16px",
                      },
                    }}
                  >
                    {[5,10, 25, 50, 100].map((size) => (
                      <MenuItem
                        key={size}
                        value={size}
                        sx={{
                          height: { xs: "40px", md: "52px" },
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "13px",
                            lg: "16px",
                          },
                        }}
                      >
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <div className="flex items-center justify-center lg:justify-start my-auto">
                  <span className="text-xs sm:text-sm my-auto lg:text-base font-medium">
                    Total Items: {totalElements}
                  </span>
                </div>
              </Stack>
              <Pagination
                count={totalPages}
                page={currentPage}
                color="primary"
                onChange={handlePageChange}
              />
             
            </Stack>
          </div>
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <TableHeader heading="" />
                <TableHeader heading="Image" />
                <TableHeader heading="Name" />
                <TableHeader heading="Description" />
                <TableHeader heading="User" />
                <TableHeader heading="Resolution" />
                <TableHeader heading="Rating" />
                <TableHeader heading="Active" />
                <TableHeader heading="Escalated" />
                <TableHeader heading="Created on" />
                <TableHeader heading="" />
              </tr>
            </thead>
            <tbody>
              {filterComplaintsByBrand(ComplaintData, filterBrands).map(
                (complaint, i) => {
                  return (
                    <tr
                      key={complaint.id}
                      style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                    >
                      <TableElement value={i + 1} />
                      <TableElement
                        value={
                          complaint.image === null || " " ? (
                            <i className="fa-regular fa-image fa-xl" />
                          ) : (
                            <img
                              alt="product"
                              src={complaint.image}
                              className="h-12 w-12 bg-white border-4"
                            />
                          )
                        }
                        type="element"
                      />
                      <TableElement
                        value={
                          <span className="font-semibold">
                            {complaint.brand.name}
                          </span>
                        }
                        type="element"
                      />
                      <TableElement value={complaint.description} />
                      <TableElement
                        value={
                          <div className="flex flex-col">
                            <span className="font-semibold">
                              {complaint.user.name}
                            </span>
                            <span className="font-semibold">
                              {complaint.user.email}
                            </span>
                            <span className="font-semibold">
                              {complaint.user.mobile}
                            </span>
                          </div>
                        }
                        type="element"
                      />
                      <TableElement value={complaint.resolution} />
                      <TableElement value={complaint.rating} />
                      <TableElement
                        value={complaint.brand.isActive}
                        type="boolean"
                      />
                      <TableElement
                        value={complaint.isEscalated}
                        type="boolean"
                      />
                      <TableElement
                        value={
                          complaint.createdOn !== null
                            ? formatDateTimeComponent(complaint.createdOn)
                            : ""
                        }
                        type="element"
                      />
                      <TableElement
                        value={
                          <span
                            className="cursor-pointer text-sky-400 md:px-4 hover:text-sky-950 font-bold gr"
                            onClick={() => {
                              setResolveComplaint(true);
                              setId(complaint.id);
                            }}
                          >
                            Resolve
                          </span>
                        }
                      />
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/*Add Complaint*/}

      <Dialog open={AddComplaint} onClose={() => setAddComplaint(false)}>
        <DialogTitle>Add Complaint</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="type-label" className="text-sm md:text-base">
                  Complaint Type
                </InputLabel>
                <Select
                  labelId="type-label"
                  id="type"
                  name="type"
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "13x",
                      md: "13px",
                      lg: "16px",
                    },
                  }}
                  value={formData.type || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                >
                  {complaintTypesAdd.map((type) => (
                    <MenuItem
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "13x",
                          md: "13px",
                          lg: "16px",
                        },
                      }}
                      key={type.value}
                      value={type.value}
                    >
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="w-full">
                <FormControl fullWidth>
                  <InputLabel
                    id="brand-select-label"
                    className="text-sm md:text-base"
                  >
                    Brand
                  </InputLabel>
                  <Select
                    labelId="brand-select-label"
                    id="brand-select"
                    value={selectedBrandDialog || ""}
                    name="Brand"
                    // label={
                    //   <span className="text-sm md:text-base font-medium">
                    //     Brand
                    //   </span>
                    // }
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13x",
                        md: "13px",
                        lg: "16px",
                      },
                    }}
                    onChange={(e) => {
                      const { id } = e.target.value;
                      setSelectedBrandDialog(e.target.value);
                      setFormData({ ...formData, brandId: id });
                    }}
                    className="min-h-[40px] md:min-h-[52px]"
                  >
                    {brands.map((brand, index) => (
                      <MenuItem
                        key={index}
                        value={brand}
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13x",
                            md: "13px",
                            lg: "16px",
                          },
                        }}
                      >
                        {brand.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="mobile"
                label="Mobile Number"
                inputProps={{
                  maxLength: 10,
                }}
                variant="standard"
                InputProps={{
                  sx: {
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "13px",
                      lg: "16px",
                    },
                  },
                }}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ width: "100%" }}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  name="description"
                  label="Description"
                  variant="standard"
                  multiline
                  rows={4}
                  InputProps={{
                    sx: {
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "13px",
                        lg: "16px",
                      },
                    },
                  }}
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <input
                accept="image/*"
                id="payment-screenshot"
                type="file"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <label htmlFor="payment-screenshot">
                <Button
                  variant="contained"
                  component="span"
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "13x",
                      md: "13px",
                      lg: "13px",
                    },
                    padding: { md: "6px 16px", xs: "2px 8px" },
                  }}
                >
                  Upload Image
                </Button>
              </label>
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Payment Screenshot Preview"
                  style={{ marginTop: 10, maxHeight: 100 }}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleSubmitForm(formData, mobile);
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <ComplaintAddDialog
        setResolveComplaint={setResolveComplaint}
        ResolveComplaint={ResolveComplaint}
        id={id}
        fetchComplaints={fetchComplaints}
      />
    </>
  );
}
